import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

const setPersonalChatPinnedSchema = z.object({
  id: z.string(),
  pinned: z.boolean(),
  // When pinning, the caller also moves the chat to the front of the list.
  position: z.number().optional(),
});

export const setPersonalChatPinned = mutator({
  schema: setPersonalChatPinnedSchema,
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    const { userId } = ctx;
    const [pc] = await tx.run(
      zql.personalChats
        .where("deletedAt", "IS", null)
        .where("id", args.id)
        .where("userId", userId)
    );
    if (!pc) return;
    await tx.mutate.personalChats.update({
      id: args.id,
      pinnedAt: args.pinned ? Date.now() : null,
      ...(args.position !== undefined ? { position: args.position } : {}),
    });
  },
});
